import { render, staticRenderFns } from "./CardListCard.vue?vue&type=template&id=edf486f2&scoped=true&"
import script from "./CardListCard.vue?vue&type=script&lang=ts&"
export * from "./CardListCard.vue?vue&type=script&lang=ts&"
import style0 from "./CardListCard.vue?vue&type=style&index=0&id=edf486f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf486f2",
  null
  
)

export default component.exports